





















































import { Component, Prop, Mixins } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import { PromotionHistory } from '@/services/connecteur'
import { dateShortFormat } from '@/filters/dateFormat'
import codeFormat from '@/filters/cmmfCodeFormat'
import moment from 'moment'

@Component({
  filters: {
    dateShortFormat
  }
})
export default class HistoryPromotionDialog extends Mixins(BaseVue) {
  @Prop({ default: false })
  public value!: boolean

  @Prop()
  public history!: PromotionHistory[]

  public closeDialog() {
    this.$emit('input', false)
  }

  public getDate(date: Date): string {
    return dateShortFormat(date)
  }

  public getChange(history: PromotionHistory) {
    const result: {
      [key: string]: any
    } = {}
    if (history.oldValues && history.newValues) {
      const oldValuesObject = JSON.parse(history.oldValues)
      const newValuesObject = JSON.parse(history.newValues)

      for (const value of Object.keys(oldValuesObject)) {
        if (value !== 'ListOfSelectedCMMF') {
          const formatedValue = this.formatData(
            value,
            oldValuesObject[value],
            newValuesObject[value]
          )
          result[formatedValue.key] = formatedValue
        }
      }
    }

    return result
  }

  private formatData(key: string, oldValue: any, newValue: any): any {
    const obj: any = {}
    obj.colspan = 1
    const listSelectedCMMF = /.*\[Code:(\d*)\]\.?(.*)/
    let olderValue = oldValue
    let recentValue = newValue
    let selectedKey = key

    if (listSelectedCMMF.test(key)) {
      const regexResult = listSelectedCMMF.exec(key) as RegExpExecArray
      const propertyMatch = regexResult[2].replace('KAM', 'kam')
      let propertyName = ''

      if (propertyMatch) {
        const propertyKey =
          propertyMatch[0].toLowerCase() + propertyMatch.substring(1)
        propertyName = ' - ' + this.$t(
          `promotionCMMF.header.${propertyKey}`
        ).toString()
      } else if (!oldValue) {
        obj.colspan = 2
        recentValue = this.$t('global.new')
      } else if (!newValue) {
        obj.colspan = 2
        olderValue = ''
        recentValue = this.$t('global.deleted')
      }

      selectedKey = `CMMF ${codeFormat(regexResult[1])}${propertyName}`
    } else {
      selectedKey = selectedKey.replace(/([A-Z][a-z])/g, ' $1').trim()
      olderValue = this.formatValue(oldValue)
      recentValue = this.formatValue(newValue)
    }

    obj.old = olderValue
    obj.new = recentValue
    obj.key = selectedKey

    return obj
  }

  private formatValue(value: any) {
    if (value !== parseInt(value, 10) && value !== parseInt(value, 10) + '' && value?.Id === undefined && moment(value).isValid()) {
      return dateShortFormat(value)
    }
    return value
  }
}
